module.exports = __webpack_public_path__ + "img/tour-max-group.cd558ea.svg";